import React, { useState, useEffect } from "react";

import './styles.css';

import productServices from '../../../services/admFin/productServices';
import compare from "../../../functions/compare";

import MainView from "../../../components/MainView";
import NavHistory from "../../../components/NavHistory";
import ProductsCard from "./ProductsCard";

export default function StockPage(props) {
    const [products, setProducts] = useState(null);

    useEffect(() => {
        readProducts();
    }, []);

    async function readProducts() {
        const response = await productServices.getProducts();
        if (response.status === 200) {
            setProducts(response.data.sort((a, b) => compare(a.nome, b.nome)));
        } else
            alert("Erro ao ler produtos, tente novamente!");
    }

    function updateProduct(product) {
        let index = products.findIndex(item => item.id === product.id);
        if (index !== -1) {
            let auxArray = products.slice();
            auxArray[index] = product;
            setProducts(auxArray);
        }
    }

    return (
        <MainView currentPage='stocks' admFinMenu>
            <NavHistory navPages={['Estoque']} />

            <div className='stock-page-cards'>
                <div className='stock-page-cards-group'>
                    <ProductsCard
                        products={products}
                        onCreate={readProducts}
                        onUpdate={updateProduct}
                    />
                </div>

                <div className='stock-page-cards-group'>
                    <ProductsCard
                        criticalMode
                        products={products}
                        onCreate={readProducts}
                        onUpdate={updateProduct}
                    />
                </div>
            </div>
        </MainView>
    )
}